core.directive('esEntityLookup', ['$timeout', '$translate', '$compile',
    function ($timeout, $translate, $compile) {
        var i = 0;
        var definition = {
            restrict: 'E',
            replace: true,
            require: '^form',
            scope: {
                value: '=',
                placeholder: '@',
                itemTemplateUrl: '@',
                required: '=',
                disabled: '=?',
                name: '@',
                tooltip: '@?',
                showLabel: '@'
            },
            controller: '@',
            name: 'controller',
            templateUrl: 'core/application/directive/esEntityLookup/template/es-entity-lookup.html',
            link: function(scope, element, attrs, formCtrl) {
                var listId = i++;
                function refreshPosition () {
                    $timeout(function () {
                        var lookupList = angular.element(document).find('#es-entity-lookup-list-' + listId);
                        lookupList.css({position: 'absolute', 'z-index': 999999});
                        lookupList.css('top', (element.offset().top - $('body').position().top) + 'px'); // mdDialog sets body position fixed and top position is equal to scrollTop value
                        lookupList.css('left', (element.offset().left - $('body').position().left) + 'px'); // mdDialog sets body position fixed and left position is equal to scrollLeft value
                    });
                }

                var list = angular.element('<ng-include id="es-entity-lookup-list-'+listId+'" src="\'core/application/directive/esEntityLookup/template/es-entity-lookup-list.html\'"></ng-include>');
                angular.element(document).find('body').eq(0).append(list);
                $compile(list)(scope);

                scope.$on('$destroy', function () {
                    angular.element(document).find('#es-entity-lookup-list-' + listId).remove();
                });


                scope.form = formCtrl;

                if(!scope.placeholder) {
                    scope.placeholder = 'T.MODULE.PATIENT.START_TYPING_TO_FIND';
                }

                if(scope.showLabel) {
                    scope._showLabel = scope.$eval(scope.showLabel);
                } else {
                    element.find('input').attr('placeholder', $translate.instant(scope.placeholder));
                }

                if(!scope.name) {
                    scope.name = 'esEntityLookup' + Math.random(); // fixme
                }

                if(!scope.itemTemplateUrl) {
                    scope.itemTemplateUrl = 'core/application/directive/esEntityLookup/template/es-entity-lookup-item.html';
                }

                scope.listVisible = false;
                scope.lookupInProgress = false;

                scope.vm = {
                    highlightedIndex: -1,
                    selectedIndex: -1
                };

                scope.searchChanged = function () {
                    scope.getData(scope.search);
                    scope.value = null;
                    scope.lastSearch = scope.search;
                    scope.vm.selectedIndex = -1;
                    scope.vm.highlightedIndex = -1;
                    if(scope.search) {
                        scope.listVisible = true;
                        refreshPosition();
                    } else {
                        scope.listVisible = false;
                    }
                };

                scope.cleanValue = function() {
                    scope.value = null;
                }

                scope.searchKeydown = function (event) {
                    if(!scope.listVisible) {
                        return;
                    }
                    if(event.keyCode === 38 || event.keyCode === 40) {
                        event.preventDefault();
                    }
                    if(scope.items.length > 0) {
                        if(event.keyCode === 38) {
                            if(scope.vm.highlightedIndex > -1) {
                                scope.vm.highlightedIndex--;
                            } else {
                                scope.vm.highlightedIndex = scope.items.length - 1;
                            }
                            scope.vm.selectedIndex = scope.vm.highlightedIndex;

                        } else if(event.keyCode === 40) {
                            if(scope.vm.highlightedIndex < scope.items.length-1) {
                                scope.vm.highlightedIndex++;
                            } else {
                                scope.vm.highlightedIndex = -1;
                            }
                            scope.vm.selectedIndex = scope.vm.highlightedIndex;
                        }
                        //if(event.keyCode === 38 || event.keyCode === 40) {
                        if(event.keyCode === 13 || event.which === 1) {
                            scope.selectItem(scope.items[scope.vm.selectedIndex]);
                        }
                        if(event.keyCode === 13 || event.keyCode === 27) {
                            scope.hideList();
                        }
                    }
                };

                scope.hideList = function () {
                    $timeout(function () {
                        scope.vm.selectedIndex = -1;
                        scope.vm.highlightedIndex = -1;
                        scope.listVisible = false;
                        if(element.find('.search-input').is(':focus')) {
                            element.find('.search-input').blur();
                        }
                        scope.lastSearch = null;
                    });
                };

                scope.selectItem = function (item) {
                    scope.value = item;
                };

                scope.selectItemAndClose = function (item) {
                    scope.selectItem(item);
                    scope.hideList();
                };

                scope.$watch('value', function (newVal, oldVal) {
                    if(newVal) {
                        scope.search = scope.getLabel(newVal);
                    } else {
                        if(newVal === null) {
                            scope.search = scope.lastSearch;
                        } else {
                            scope.search = null;
                            scope.items = [];
                        }
                    }
                });

                scope.$watchCollection('items', function () {
                    refreshPosition();
                });

                scope.items = [];

            }
        };

        return definition;
    }
]);